import * as tslib_1 from "tslib";
import { delegateCombine, delegateRemove } from "igniteui-react-core";
import { IgrTemplateHeaderCellUpdatingEventArgs } from "./igr-template-header-cell-updating-event-args";
import { IgrHeader } from "./igr-header";
import { TemplateHeader } from "./TemplateHeader";
/**
 * A type of header with customizable content.
*/
var IgrTemplateHeader = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrTemplateHeader, _super);
    function IgrTemplateHeader(props) {
        var _this = _super.call(this, props) || this;
        _this._cellUpdating = null;
        _this._cellUpdating_wrapped = null;
        return _this;
    }
    IgrTemplateHeader.prototype.createImplementation = function () {
        return new TemplateHeader();
    };
    Object.defineProperty(IgrTemplateHeader.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrTemplateHeader.prototype, "cellUpdating", {
        /**
         * Called when the header cell content is being created or updated.
        */
        get: function () {
            return this._cellUpdating;
        },
        set: function (ev) {
            var _this = this;
            if (this._cellUpdating_wrapped !== null) {
                this.i.cellUpdating = delegateRemove(this.i.cellUpdating, this._cellUpdating_wrapped);
                this._cellUpdating_wrapped = null;
                this._cellUpdating = null;
            }
            this._cellUpdating = ev;
            this._cellUpdating_wrapped = function (o, e) {
                var outerArgs = new IgrTemplateHeaderCellUpdatingEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeCellUpdating) {
                    _this.beforeCellUpdating(_this, outerArgs);
                }
                if (_this._cellUpdating) {
                    _this._cellUpdating(_this, outerArgs);
                }
            };
            this.i.cellUpdating = delegateCombine(this.i.cellUpdating, this._cellUpdating_wrapped);
        },
        enumerable: true,
        configurable: true
    });
    return IgrTemplateHeader;
}(IgrHeader));
export { IgrTemplateHeader };
//# sourceMappingURL=igr-template-header.js.map
